import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import "./Gallery.css";

import a1 from "../../assets/Peugeot 308/1.jpg";
import a2 from "../../assets/Peugeot 308/2.jpg";
import a3 from "../../assets/Peugeot 308/3.jpg";
import a4 from "../../assets/Peugeot 308/4.jpg";
import a5 from "../../assets/Peugeot 308/5.jpg";
import a6 from "../../assets/Peugeot 308/6.jpg";

import b1 from "../../assets/Ford Ecosport/1.jpg";
import b2 from "../../assets/Ford Ecosport/2.jpg";
import b3 from "../../assets/Ford Ecosport/3.jpg";
import b4 from "../../assets/Ford Ecosport/4.jpg";
import b5 from "../../assets/Ford Ecosport/5.jpg";
import b6 from "../../assets/Ford Ecosport/6.jpg";

import c1 from "../../assets/citroen c3/1.jpg";
import c2 from "../../assets/citroen c3/2.jpg";
import c3 from "../../assets/citroen c3/3.jpg";
import c4 from "../../assets/citroen c3/4.jpg";
import c5 from "../../assets/citroen c3/5.jpg";
import c6 from "../../assets/citroen c3/6.jpg";

import d1 from "../../assets/vw up/1.jpeg";
import d2 from "../../assets/vw up/2.jpeg";
import d3 from "../../assets/vw up/3.jpeg";
import d4 from "../../assets/vw up/4.jpeg";
import d5 from "../../assets/vw up/5.jpeg";
import d6 from "../../assets/vw up/6.jpeg";

const Gallery = () => {
  return (
    <>
      <div className="container-g pb-5" id="gallery">
        <Container fluid className="text-center container">
          <h2 className="fs-1 fw-bold text-dark pt-5">GALERIA</h2>
          <Row className="mt-5 align-items-stretch justify-content-center grid-g">
            <Col className="d-flex align-items-center justify-content-center carousel-container">
              <Carousel>
                <Carousel.Item>
                  <img
                    src={a1}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.1"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={a2}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.2"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={a3}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.3"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={a4}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.4"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={a5}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.5"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={a6}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 1.6"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col className="d-flex align-items-center justify-content-center carousel-container">
              <Carousel>
                <Carousel.Item>
                  <img
                    src={b1}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.1"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={b2}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.2"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={b3}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.3"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={b4}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.4"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={b5}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.5"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={b6}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 2.6"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
          </Row>
          <Row className="mt-5 align-items-stretch justify-content-center grid-g">
            <Col className="d-flex align-items-center justify-content-center carousel-container">
              <Carousel>
                <Carousel.Item>
                  <img
                    src={c1}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.1"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={c2}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.2"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={c3}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.3"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={c4}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.4"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={c5}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.5"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={c6}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 3.6"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col className="d-flex align-items-center justify-content-center carousel-container">
              <Carousel>
                <Carousel.Item>
                  <img
                    src={d1}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.1"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={d2}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.2"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={d3}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.3"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={d4}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.4"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={d5}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.5"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={d6}
                    className="img-fluid shadow img-round"
                    alt="Imagen del auto 4.6"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Gallery;
